'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var constants = require('../../constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Item = styled__default["default"].li`
  user-select: none;
`;
const ItemLabel = styled__default["default"].label`
  display: block;
`;
const ItemContentWrapper = styled__default["default"].div(
  ({ alignMenu, hoverColor }) => `
  display: flex;
  align-items: center;
  text-align: left;
  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    grid-template-columns: 
      ${alignMenu === coreRenderer.Alignment.left ? "auto 1fr auto" : ""}
      ${alignMenu === coreRenderer.Alignment.center ? "1fr auto 1fr" : ""}
      ${alignMenu === coreRenderer.Alignment.right ? "1fr auto" : ""}
    ;
    display: grid;
  }

  ${hoverColor ? `a:hover ~ svg{
    color: ${hoverColor} !important;
  }` : ""}
`
);
const ItemContent = styled__default["default"].a(({ grid, alignMenu }) => {
  const {
    menuItemSpacing,
    menuColor,
    menuHoverColor,
    mobileNavigationTextAlign
  } = grid || {};
  return `
  position: relative;
  align-self: center;
  margin: 0 0 0 ${menuItemSpacing}px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: ${menuColor};

  &:hover {
    text-decoration: underline;
    text-underline-offset: 7px;
    color: ${menuHoverColor};
  }

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
    margin: 0;
    text-align: ${mobileNavigationTextAlign};

    grid-column: 
    ${alignMenu === coreRenderer.Alignment.left ? "1/2" : ""}
    ${alignMenu === coreRenderer.Alignment.center ? "2/3" : ""}
    ${alignMenu === coreRenderer.Alignment.right ? "3/4" : ""}
  }
`;
});
const ItemIcon = styled__default["default"].img`
  width: 20px;
  height: 20px;
  margin-right: 0.4em;
`;

exports.Item = Item;
exports.ItemContent = ItemContent;
exports.ItemContentWrapper = ItemContentWrapper;
exports.ItemIcon = ItemIcon;
exports.ItemLabel = ItemLabel;
